module.exports = __webpack_public_path__ + "img/camera_with_height.d6e2828c.jpg";